import React from "react";
import PropTypes from "prop-types";

import { useOnboardingStepsData } from "scenes/Onboarding/components/OnboardingStepsProvider";

import { FutureDate, Money } from "./components";

function Disclaimer({ currency, value, period }) {
  const { store } = useOnboardingStepsData();

  return (
    <div
      data-test="disclaimer-container"
      style={{
        display: "flex",
        marginTop: "20px",
        justifyContent: "center",
      }}
    >
      On&nbsp;
      <FutureDate period={period} />
      &nbsp;you&apos;ll be charged&nbsp;
      <Money currency={currency}>
        {store?.subscription?.discountedBillingPrice?.total || value}
      </Money>{" "}
      (plus tax). Cancel your trial before&nbsp;
      <FutureDate period={period} />
      &nbsp;to not be charged.&nbsp;<i>All amounts are in {currency}</i>
    </div>
  );
}

Disclaimer.propTypes = {
  currency: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  period: PropTypes.object.isRequired,
};

export default Disclaimer;
